import { UserDataLayerAdapter } from "./UserDataLayerAdapter";
import { User } from "../gtm/User";

/**
 * This abstract class is used to specify which class should be used
 * as an adapter between this library and the DataLayer for user data.
 */
export abstract class UserDataLayerAdapterFactory {
  abstract getUserDataAdapter(user: User): UserDataLayerAdapter;
}
